/****************************************************************************
 Copyright (c) 2013-2014 Chukong Technologies Inc.

 http://www.cocos2d-x.org

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 ****************************************************************************/

(function(){
    sp.Skeleton.WebGLRenderCmd = function (renderableObject) {
        cc.Node.WebGLRenderCmd.call(this, renderableObject);
        this._needDraw = true;
        this._matrix = new cc.math.Matrix4();
        this._matrix.identity();
        this._tmpQuad = new cc.V3F_C4B_T2F_Quad();
        this._vfCount = 0;
        this._indexCount = 0;
        this._indexOffset = 0;
        this._segVCount = 0;
        this._perVertexSize = 6;
        this._vfOffset = 0;
        this._indices = [];
        this._tmpClipQuads = [];
        this.batcher = new spine.webgl.PolygonBatcher();
        this.skeletonRenderer = new spine.webgl.SkeletonRenderer();
        this.setShaderProgram(cc.shaderCache.programForKey(cc.SHADER_POSITION_TEXTURECOLOR));
    };

    var proto = sp.Skeleton.WebGLRenderCmd.prototype = Object.create(cc.Node.WebGLRenderCmd.prototype);
    proto.constructor = sp.Skeleton.WebGLRenderCmd;


    proto.hasCache = function (timeScale) {
        var node = this._node

        if (node.getCurrent(0)){
            this.animationName = node.getCurrent(0).animation.name
            this.frameIndex = Math.floor(node.getCurrent(0).getAnimationTime() * frameRate / timeScale)
            return cc.loader.getSpineFramesCache(node.argSkeletonFile, this.animationName, this.frameIndex) && cc.loader.getSpineCache(node.argAtlasFile).atlas
        }
        return false

    }
    proto.rendering = function (ctx) {
        if (this._node.version == "3.8.95"){
            var node = this._node
        
            var wt = this._worldTransform;
            this._matrix.mat[0] = wt.a;
            this._matrix.mat[4] = wt.c;
            this._matrix.mat[12] = wt.tx;
            this._matrix.mat[1] = wt.b;
            this._matrix.mat[5] = wt.d;
            this._matrix.mat[13] = wt.ty;
    
            this._shaderProgram.use();
            this._shaderProgram._setUniformForMVPMatrixWithMat4(this._matrix);
            this.batcher._matrix = this._matrix
            let cache = cc.loader.getSpineFramesCache(node.argSkeletonFile, this.animationName, this.frameIndex)
    
            let atlas = cc.loader.getSpineCache(node.argAtlasFile).atlas
            if (cache && atlas){
    
                for (let key in cache){
                    if (cache[key]){
                        this.batcher.drawWithCache(atlas, cache[key][0], cache[key][1], cache[key][2], cache[key][3])
                        // if (!window.finish){
                        //     console.log("usecache", node.argSkeletonFile, this.animationName, this.frameIndex)
                        //     window.finish = true
                        // }
                    }
                }
                
            }else {
                // console.log("nocache", node.argSkeletonFile, this.animationName, this.frameIndex)
                var color = node.getColor(), locSkeleton = node._skeleton;
                locSkeleton.color.r = color.r / 255;
                locSkeleton.color.g = color.g / 255;
                locSkeleton.color.b = color.b / 255;
                locSkeleton.color.a = node.getOpacity() / 255;
                this.batcher.begin();
                this.skeletonRenderer.draw(this.batcher, node._skeleton );
                this.batcher.end();
    
            }
    
            return
        }
        
       
        this._indexOffset = 0;
        var node = this._node, tmpQuad = this._tmpQuad;
        this._tmpClipQuads = [];
        var color = node.getColor(), locSkeleton = node._skeleton;
        var clipper = node._clipper;

        var blendMode, textureAtlas, attachment, slot, i, n;
        var locBlendFunc = node._blendFunc;
        var premultiAlpha = node._premultipliedAlpha;

        var wt = this._worldTransform;
        this._matrix.mat[0] = wt.a;
        this._matrix.mat[4] = wt.c;
        this._matrix.mat[12] = wt.tx;
        this._matrix.mat[1] = wt.b;
        this._matrix.mat[5] = wt.d;
        this._matrix.mat[13] = wt.ty;

        this._shaderProgram.use();
        this._shaderProgram._setUniformForMVPMatrixWithMat4(this._matrix);
        // cc.glBlendFunc(locBlendFunc.src, locBlendFunc.dst);
        locSkeleton.r = color.r / 255;
        locSkeleton.g = color.g / 255;
        locSkeleton.b = color.b / 255;
        locSkeleton.a = node.getOpacity() / 255;
        if (premultiAlpha) {
            locSkeleton.r *= locSkeleton.a;
            locSkeleton.g *= locSkeleton.a;
            locSkeleton.b *= locSkeleton.a;
        }

        var isRegion = void 0, isMesh = void 0, isClip = void 0;
        var triangles = void 0;
        this._vfOffset = 0;
        for (i = 0, n = locSkeleton.drawOrder.length; i < n; i++) {
            if(window.useSPineOld){
                slot = locSkeleton.drawOrder[i];
                if (!slot.attachment)
                    continue;
                attachment = slot.attachment;
    
                var isRegion = attachment instanceof spine.RegionAttachment;
                var isMesh = attachment instanceof spine.MeshAttachment;
                //var isClip = attachment instanceof spine.ClippingAttachment;
                if (isRegion){
                    this._updateRegionAttachmentQuad(attachment, slot, tmpQuad, premultiAlpha);
                }else if (isMesh){
                    this._updateMeshAttachmentQuad(attachment, slot, tmpQuad, premultiAlpha);
                }else{
                }

            }else{
                slot = locSkeleton.drawOrder[i];
                this._vfCount = 0;
                this._indexCount = 0;
                attachment = slot.getAttachment();
                if (!attachment){
                    clipper.clipEndWithSlot(slot);
                    continue;
                }
    
                isRegion = attachment instanceof spine.RegionAttachment;
                isMesh = attachment instanceof spine.MeshAttachment;
                isClip = attachment instanceof spine.ClippingAttachment;
    
                if (isClip) {
                    clipper.clipStart(slot, attachment);
                    continue;
                }
                if (!isRegion && !isMesh) {
                    clipper.clipEndWithSlot(slot);
                    continue;
                }
                this._indices = []
                if (isRegion){
                    triangles = [0,1,2,2,3,0];
                    for (var ii = 0, jj = this._indexOffset, nn = triangles.length; ii < nn;) {
                        this._indices[jj++] = triangles[ii++];
                    }
                    this._vfCount = 4 * this._perVertexSize;
                    this._indexCount = 6;
                    this._updateRegionAttachmentQuad(attachment, slot, tmpQuad, premultiAlpha, clipper);
                }else if (isMesh){
                    triangles = attachment.triangles;
                    for (var ii = 0, jj = this._indexOffset, nn = triangles.length; ii < nn;) {
                        this._indices[jj++] = triangles[ii++];
                    }
                    this._vfCount = (attachment.worldVerticesLength >> 1) * this._perVertexSize;
                    this._indexCount = triangles.length;
                    this._updateMeshAttachmentQuad(attachment, slot, tmpQuad, premultiAlpha, clipper);
                }

                if (this._indexCount > 0){
                    // for (var _ii = this._indexOffset, _nn = this._indexOffset + this._indexCount; _ii < _nn; _ii++) {
                    //     this._indices[_ii] += this._segVCount;
                    // }
                    //this._vfOffset = this._vfOffset + this._vfCount;
                    //this._indexOffset = this._indexOffset + this._indexCount;
                    //this._segVCount += this._vfCount / this._perVertexSize;
                }
            }

            var regionTextureAtlas = node.getTextureAtlas(attachment);

            if (slot.data.blendMode != blendMode) {
                if (textureAtlas) {
                    textureAtlas.drawQuads();
                    textureAtlas.removeAllQuads();
                }
                blendMode = slot.data.blendMode;
                switch (blendMode) {
                case spine.BlendMode.Additive:
                    cc.glBlendFunc(premultiAlpha ? cc.ONE : cc.SRC_ALPHA, cc.ONE);
                    break;
                case spine.BlendMode.Multiply:
                    cc.glBlendFunc(cc.DST_COLOR, cc.ONE_MINUS_SRC_ALPHA);
                    break;
                case spine.BlendMode.Screen:
                    cc.glBlendFunc(cc.ONE, cc.ONE_MINUS_SRC_COLOR);
                    break;
                default:
                    cc.glBlendFunc(locBlendFunc.src, locBlendFunc.dst);
                }
            } else if (regionTextureAtlas != textureAtlas && textureAtlas) {
                textureAtlas.drawQuads();
                textureAtlas.removeAllQuads();
            }
            textureAtlas = regionTextureAtlas;

            var quadCount = textureAtlas.getTotalQuads();
            var needResize = false
            if (window.useSPineOld){
                needResize = (textureAtlas.getCapacity() == quadCount)
            }else{
                var clipQuadCount = this._tmpClipQuads.length;
                needResize = (textureAtlas.getCapacity() <= (quadCount + clipQuadCount))
            }
            if (needResize) {
                textureAtlas.drawQuads();
                textureAtlas.removeAllQuads();
                if (!textureAtlas.resizeCapacity(textureAtlas.getCapacity() * 2)){
                    if(!window.useSPineOld){
                        clipper.clipEndWithSlot(slot);
                    }
                    return;
                }
            }

            if(window.useSPineOld){
                textureAtlas.updateQuad(tmpQuad, quadCount);
            }else{
                var tmpCount = this._tmpClipQuads.length;
                for (var ii = 0; ii < tmpCount; ++ii){
                    textureAtlas.updateQuad(this._tmpClipQuads[ii], quadCount);
                    quadCount ++;
                }
            }

            if(!window.useSPineOld){
                clipper.clipEndWithSlot(slot);
            }
        }
        if(!window.useSPineOld){
            clipper.clipEnd();
        }

        if (textureAtlas) {
            textureAtlas.drawQuads();
            textureAtlas.removeAllQuads();
        }
    };

    proto._createChildFormSkeletonData = function(){};

    proto._updateChild = function(){};

    proto._updateRegionAttachmentQuad = function(attachment, slot, quad, premultipliedAlpha,clipper) {
        this._tmpClipQuads = [];
        var vertices = {}; 
        this._vfOffset = 0
        //TODO:newadd
        this._indexOffset =0;
        var r;
        var g;
        var b;
        var normalizedAlpha;
        if (window.useSPineOld){
            attachment.computeVertices(slot.bone.skeleton.x, slot.bone.skeleton.y, slot.bone, vertices);
            r = slot.bone.skeleton.r * slot.r * 255;
            g = slot.bone.skeleton.g * slot.g * 255;
            b = slot.bone.skeleton.b * slot.b * 255;
            normalizedAlpha = slot.bone.skeleton.a * slot.a;

        }else{
            attachment.computeWorldVertices(slot.bone, vertices, this._vfOffset, this._perVertexSize)
            var attColor = attachment.color;
            var slotColor = slot.color;
            r = slot.bone.skeleton.r * slotColor.r * attColor.a * 255;
            g = slot.bone.skeleton.g * slotColor.g * attColor.a * 255;
            b = slot.bone.skeleton.b * slotColor.b * attColor.a *  255;
            normalizedAlpha = slot.bone.skeleton.a * attColor.a *  slotColor.a;
        }

        if (premultipliedAlpha) {
            r *= normalizedAlpha;
            g *= normalizedAlpha;
            b *= normalizedAlpha;
        }
        var a = normalizedAlpha * 255;


        var VERTEX = sp.VERTEX_INDEX;
        if (window.useSPineOld){
            quad.bl.colors.r = quad.tl.colors.r = quad.tr.colors.r = quad.br.colors.r = r;
            quad.bl.colors.g = quad.tl.colors.g = quad.tr.colors.g = quad.br.colors.g = g;
            quad.bl.colors.b = quad.tl.colors.b = quad.tr.colors.b = quad.br.colors.b = b;
            quad.bl.colors.a = quad.tl.colors.a = quad.tr.colors.a = quad.br.colors.a = a;

            quad.bl.vertices.x = vertices[VERTEX.X1];
            quad.bl.vertices.y = vertices[VERTEX.Y1];
            quad.tl.vertices.x = vertices[VERTEX.X2];
            quad.tl.vertices.y = vertices[VERTEX.Y2];
            quad.tr.vertices.x = vertices[VERTEX.X3];
            quad.tr.vertices.y = vertices[VERTEX.Y3];
            quad.br.vertices.x = vertices[VERTEX.X4];
            quad.br.vertices.y = vertices[VERTEX.Y4];
            
            quad.bl.texCoords.u = attachment.uvs[VERTEX.X1];
            quad.bl.texCoords.v = attachment.uvs[VERTEX.Y1];
            quad.tl.texCoords.u = attachment.uvs[VERTEX.X2];
            quad.tl.texCoords.v = attachment.uvs[VERTEX.Y2];
            quad.tr.texCoords.u = attachment.uvs[VERTEX.X3];
            quad.tr.texCoords.v = attachment.uvs[VERTEX.Y3];
            quad.br.texCoords.u = attachment.uvs[VERTEX.X4];
            quad.br.texCoords.v = attachment.uvs[VERTEX.Y4];
        }else{
            // var _finalColor32 = (_finalColor.a << 24 >>> 0) + (_finalColor.b << 16) + (_finalColor.g << 8) + _finalColor.r;
            // var _darkColor32 = (_darkColor.a << 24 >>> 0) + (_darkColor.b << 16) + (_darkColor.g << 8) + _darkColor.r;
            for (var v = this._vfOffset, n = this._vfOffset + this._vfCount, u = 0; v < n; v += this._perVertexSize, u += 2) {
                vertices[v + 2] = attachment.uvs[u];
                vertices[v + 3] = attachment.uvs[u + 1];
            }

            if (!clipper.isClipping()){
                quad.bl.colors.r = quad.tl.colors.r = quad.tr.colors.r = quad.br.colors.r = r;
                quad.bl.colors.g = quad.tl.colors.g = quad.tr.colors.g = quad.br.colors.g = g;
                quad.bl.colors.b = quad.tl.colors.b = quad.tr.colors.b = quad.br.colors.b = b;
                quad.bl.colors.a = quad.tl.colors.a = quad.tr.colors.a = quad.br.colors.a = a;

                quad.bl.vertices.x = vertices[this._vfOffset];
                quad.bl.vertices.y = vertices[this._vfOffset + 1];
                quad.tl.vertices.x = vertices[this._vfOffset + this._perVertexSize];
                quad.tl.vertices.y = vertices[this._vfOffset + this._perVertexSize+1];
                quad.tr.vertices.x = vertices[this._vfOffset + this._perVertexSize*2];
                quad.tr.vertices.y = vertices[this._vfOffset + this._perVertexSize*2+1];
                quad.br.vertices.x = vertices[this._vfOffset + this._perVertexSize*3];
                quad.br.vertices.y = vertices[this._vfOffset + this._perVertexSize*3+1];
                
                quad.bl.texCoords.u = attachment.uvs[VERTEX.X1];
                quad.bl.texCoords.v = attachment.uvs[VERTEX.Y1];
                quad.tl.texCoords.u = attachment.uvs[VERTEX.X2];
                quad.tl.texCoords.v = attachment.uvs[VERTEX.Y2];
                quad.tr.texCoords.u = attachment.uvs[VERTEX.X3];
                quad.tr.texCoords.v = attachment.uvs[VERTEX.Y3];
                quad.br.texCoords.u = attachment.uvs[VERTEX.X4];
                quad.br.texCoords.v = attachment.uvs[VERTEX.Y4];
                this._tmpClipQuads[0] = quad;
            }else{
                var _finalColor = new spine.Color(r, g, b, a);
                var _darkColor = new spine.Color(255, 255, 255, 255);
                var a = this._updateClipdataInternal(vertices, clipper, _finalColor, _darkColor, attachment);
            }
        }

    };

    proto._updateMeshAttachmentQuad = function(attachment, slot, quad, premultipliedAlpha, clipper) {
        this._tmpClipQuads = [];
        var vertices = {};
        this._vfOffset = 0
        //TODO:newadd
        this._indexOffset =0;
        attachment.computeWorldVertices(slot,0, attachment.worldVerticesLength, vertices, this._vfOffset, this._perVertexSize);
        var r = 255;
        var g = 255;
        var b = 255;
        var normalizedAlpha = 255;
        if(window.useSPineOld){
            r = slot.bone.skeleton.r * slot.r * 255;
            g = slot.bone.skeleton.g * slot.g * 255;
            b = slot.bone.skeleton.b * slot.b * 255;
            normalizedAlpha = slot.bone.skeleton.a * slot.a;
        }else{
            var attColor = attachment.color;
            var slotColor = slot.color;
            r = slot.bone.skeleton.r * slotColor.r * attColor.a * 255;
            g = slot.bone.skeleton.g * slotColor.g * attColor.a * 255;
            b = slot.bone.skeleton.b * slotColor.b * attColor.a *  255;
            normalizedAlpha = slot.bone.skeleton.a * attColor.a *  slotColor.a;
        }
        if (premultipliedAlpha) {
            r *= normalizedAlpha;
            g *= normalizedAlpha;
            b *= normalizedAlpha;
        }
        var a = normalizedAlpha * 255;

        quad.bl.colors.r = quad.tl.colors.r = quad.tr.colors.r = quad.br.colors.r = r;
        quad.bl.colors.g = quad.tl.colors.g = quad.tr.colors.g = quad.br.colors.g = g;
        quad.bl.colors.b = quad.tl.colors.b = quad.tr.colors.b = quad.br.colors.b = b;
        quad.bl.colors.a = quad.tl.colors.a = quad.tr.colors.a = quad.br.colors.a = a;

        var VERTEX = sp.VERTEX_INDEX;
        if(window.useSPineOld){
            quad.bl.vertices.x = vertices[VERTEX.X1];
            quad.bl.vertices.y = vertices[VERTEX.Y1];
            quad.tl.vertices.x = vertices[VERTEX.X2];
            quad.tl.vertices.y = vertices[VERTEX.Y2];
            quad.tr.vertices.x = vertices[VERTEX.X3];
            quad.tr.vertices.y = vertices[VERTEX.Y3];
            quad.br.vertices.x = vertices[VERTEX.X4];
            quad.br.vertices.y = vertices[VERTEX.Y4];
        }else{
            var _finalColor = new spine.Color(r, g, b, a);
            if (!clipper.isClipping()){
                if (attachment.triangles != null){
                    this._updateVertices(attachment, vertices, _finalColor)
                }else{
                    quad.bl.colors.r = quad.tl.colors.r = quad.tr.colors.r = quad.br.colors.r = r;
                    quad.bl.colors.g = quad.tl.colors.g = quad.tr.colors.g = quad.br.colors.g = g;
                    quad.bl.colors.b = quad.tl.colors.b = quad.tr.colors.b = quad.br.colors.b = b;
                    quad.bl.colors.a = quad.tl.colors.a = quad.tr.colors.a = quad.br.colors.a = a;
    
                    quad.bl.vertices.x = vertices[this._vfOffset];
                    quad.bl.vertices.y = vertices[this._vfOffset + 1];
                    quad.tl.vertices.x = vertices[this._vfOffset + this._perVertexSize];
                    quad.tl.vertices.y = vertices[this._vfOffset + this._perVertexSize+1];
                    quad.tr.vertices.x = vertices[this._vfOffset + this._perVertexSize*2];
                    quad.tr.vertices.y = vertices[this._vfOffset + this._perVertexSize*2+1];
                    quad.br.vertices.x = vertices[this._vfOffset + this._perVertexSize*3];
                    quad.br.vertices.y = vertices[this._vfOffset + this._perVertexSize*3+1];
                    
                    quad.bl.texCoords.u = attachment.uvs[VERTEX.X1];
                    quad.bl.texCoords.v = attachment.uvs[VERTEX.Y1];
                    quad.tl.texCoords.u = attachment.uvs[VERTEX.X2];
                    quad.tl.texCoords.v = attachment.uvs[VERTEX.Y2];
                    quad.tr.texCoords.u = attachment.uvs[VERTEX.X3];
                    quad.tr.texCoords.v = attachment.uvs[VERTEX.Y3];
                    quad.br.texCoords.u = attachment.uvs[VERTEX.X4];
                    quad.br.texCoords.v = attachment.uvs[VERTEX.Y4];
                    this._tmpClipQuads[0] = quad;

                }
            }else{
                var _darkColor = new spine.Color(255, 255, 255, 255);
                var a = this._updateClipdataInternal(vertices, clipper, _finalColor, _darkColor, attachment);
            }
        }
    };
    
    proto._updateVertices =  function(attachment, vertices, finalColor){
        var tmpQuadCount = Math.ceil(attachment.triangles.length / 3);
        var lastInfo = {}
        var indiceIndex = 0;
        var realIndex = 0
        for (var i=0; i<tmpQuadCount;++i){
            var tmpQuad = new cc.V3F_C4B_T2F_Quad();

            tmpQuad.bl.colors.r = tmpQuad.tl.colors.r = tmpQuad.tr.colors.r = tmpQuad.br.colors.r = finalColor.r;
            tmpQuad.bl.colors.g = tmpQuad.tl.colors.g = tmpQuad.tr.colors.g = tmpQuad.br.colors.g = finalColor.g;
            tmpQuad.bl.colors.b = tmpQuad.tl.colors.b = tmpQuad.tr.colors.b = tmpQuad.br.colors.b = finalColor.b;
            tmpQuad.bl.colors.a = tmpQuad.tl.colors.a = tmpQuad.tr.colors.a = tmpQuad.br.colors.a = finalColor.a;
            
            realIndex = attachment.triangles[indiceIndex]
            if (vertices[realIndex*6]){
                tmpQuad.tl.vertices.x = lastInfo.x = vertices[realIndex*6];
                tmpQuad.tl.vertices.y = lastInfo.y = vertices[realIndex*6 + 1];
                tmpQuad.tl.texCoords.u = lastInfo.u = attachment.uvs[realIndex*2];
                tmpQuad.tl.texCoords.v = lastInfo.v = attachment.uvs[realIndex*2 + 1];
            }else{
                tmpQuad.tl.vertices.x = lastInfo.x;
                tmpQuad.tl.vertices.y = lastInfo.y;
                tmpQuad.tl.texCoords.u = lastInfo.u;
                tmpQuad.tl.texCoords.v = lastInfo.v;
            }
            //1
            indiceIndex++;
            if (indiceIndex >= attachment.triangles.length){
                indiceIndex = attachment.triangles -1
            }
            realIndex = attachment.triangles[indiceIndex]
            if (vertices[realIndex*6]){
                tmpQuad.bl.vertices.x = lastInfo.x = vertices[realIndex*6];
                tmpQuad.bl.vertices.y = lastInfo.y = vertices[realIndex*6 + 1];
                tmpQuad.bl.texCoords.u = lastInfo.u = attachment.uvs[realIndex*2];
                tmpQuad.bl.texCoords.v = lastInfo.v = attachment.uvs[realIndex*2 + 1];
            }else{
                tmpQuad.bl.vertices.x = lastInfo.x;
                tmpQuad.bl.vertices.y = lastInfo.y;
                tmpQuad.bl.texCoords.u = lastInfo.u;
                tmpQuad.bl.texCoords.v = lastInfo.v;
            }
            //2
            indiceIndex++; 
            if (indiceIndex >= attachment.triangles.length){
                indiceIndex = attachment.triangles -1
            }
            realIndex = attachment.triangles[indiceIndex]
            if (vertices[realIndex*6]){
                tmpQuad.tr.vertices.x = lastInfo.x = vertices[realIndex*6];
                tmpQuad.tr.vertices.y = lastInfo.y = vertices[realIndex*6 + 1];
                tmpQuad.tr.texCoords.u = lastInfo.u = attachment.uvs[realIndex*2];
                tmpQuad.tr.texCoords.v = lastInfo.v = attachment.uvs[realIndex*2 + 1];
            }else{
                tmpQuad.tr.vertices.x = lastInfo.x;
                tmpQuad.tr.vertices.y = lastInfo.y;
                tmpQuad.tr.texCoords.u = lastInfo.u;
                tmpQuad.tr.texCoords.v = lastInfo.v;
            }
            //3
            tmpQuad.br.vertices.x = lastInfo.x;
            tmpQuad.br.vertices.y = lastInfo.y;
            tmpQuad.br.texCoords.u = lastInfo.u;
            tmpQuad.br.texCoords.v = lastInfo.v;
    
            this._tmpClipQuads[i] = tmpQuad;

            indiceIndex++; 
            if (indiceIndex >= attachment.triangles.length){
                indiceIndex = attachment.triangles.length -1
            }
        }
    }

    proto._updateClipdataInternal = function(vertices, clipper, _finalColor, _darkColor, attachment) {
        var _perClipVertexSize = 12;

        clipper.clipTriangles(vertices, this._vfCount, this._indices, this._indexCount, vertices, 
            _finalColor, _darkColor, true, this._perVertexSize, this._indexOffset, 
            this._vfOffset, this._vfOffset + 2);

        var clippedVertices = clipper.clippedVertices;
        var clippedTriangles = clipper.clippedTriangles;
        this._indexCount = clippedTriangles.length;
        if (this._indexCount <=0){
            return false
        }
        this._vfCount = clippedVertices.length / _perClipVertexSize * this._perVertexSize;
        for (var ii = 0, jj = this._indexOffset, nn = clippedTriangles.length; ii < nn;) {
            this._indices[jj++] = clippedTriangles[ii++];
        }
        
        vertices = {}
        for (var _v = 0, _n = clippedVertices.length, offset = this._vfOffset; _v < _n; _v += 12, offset += this._perVertexSize) {
            vertices[offset] = clippedVertices[_v];
            vertices[offset + 1] = clippedVertices[_v + 1];
    
            vertices[offset + 2] = clippedVertices[_v + 6];
            vertices[offset + 3] = clippedVertices[_v + 7];
    
            //vertices[offset + 4] = _finalColor32;
            //vertices[offset + 5] = _darkColor32;
        }
    
        //var tmpQuadCount = Math.ceil(this._indices.length / 6);
        var tmpQuadCount = Math.ceil(this._indices.length / 3);
        var lastInfo = {}

        var indiceIndex = 0;
        var realIndex = 0
        for (var i=0; i<tmpQuadCount;++i){
            var tmpQuad = new cc.V3F_C4B_T2F_Quad();
            tmpQuad.bl.colors.r = tmpQuad.tl.colors.r = tmpQuad.tr.colors.r = tmpQuad.br.colors.r = _finalColor.r;
            tmpQuad.bl.colors.g = tmpQuad.tl.colors.g = tmpQuad.tr.colors.g = tmpQuad.br.colors.g = _finalColor.g;
            tmpQuad.bl.colors.b = tmpQuad.tl.colors.b = tmpQuad.tr.colors.b = tmpQuad.br.colors.b = _finalColor.b;
            tmpQuad.bl.colors.a = tmpQuad.tl.colors.a = tmpQuad.tr.colors.a = tmpQuad.br.colors.a = _finalColor.a;
            
            //0_tl 1_bl 2_tr 3_br
            realIndex = this._indices[indiceIndex]*this._perVertexSize
            if (vertices[realIndex]){
                tmpQuad.tl.vertices.x = lastInfo.x = vertices[realIndex];
                tmpQuad.tl.vertices.y = lastInfo.y = vertices[realIndex + 1];
                tmpQuad.tl.texCoords.u = lastInfo.u = vertices[realIndex + 2];
                tmpQuad.tl.texCoords.v = lastInfo.v = vertices[realIndex + 3];
            }else{
                tmpQuad.tl.vertices.x = lastInfo.x;
                tmpQuad.tl.vertices.y = lastInfo.y;
                tmpQuad.tl.texCoords.u = lastInfo.u;
                tmpQuad.tl.texCoords.v = lastInfo.v;
            }
            //1
            indiceIndex++;
            if (indiceIndex >= this._indices.length){
                indiceIndex = this._indices.length -1
            }
            realIndex = this._indices[indiceIndex]*this._perVertexSize
            if (vertices[realIndex]){
                tmpQuad.bl.vertices.x = lastInfo.x = vertices[realIndex];
                tmpQuad.bl.vertices.y = lastInfo.y = vertices[realIndex + 1];
                tmpQuad.bl.texCoords.u = lastInfo.u = vertices[realIndex + 2];
                tmpQuad.bl.texCoords.v = lastInfo.v = vertices[realIndex + 3];
            }else{
                tmpQuad.bl.vertices.x = lastInfo.x;
                tmpQuad.bl.vertices.y = lastInfo.y;
                tmpQuad.bl.texCoords.u = lastInfo.u;
                tmpQuad.bl.texCoords.v = lastInfo.v;
            }
            //2
            indiceIndex++; 
            if (indiceIndex >= this._indices.length){
                indiceIndex = this._indices.length -1
            }
            realIndex = this._indices[indiceIndex]*this._perVertexSize
            if (vertices[realIndex]){
                tmpQuad.tr.vertices.x = lastInfo.x = vertices[realIndex];
                tmpQuad.tr.vertices.y = lastInfo.y = vertices[realIndex + 1];
                tmpQuad.tr.texCoords.u = lastInfo.u = vertices[realIndex + 2];
                tmpQuad.tr.texCoords.v = lastInfo.v = vertices[realIndex + 3];
            }else{
                tmpQuad.tr.vertices.x = lastInfo.x;
                tmpQuad.tr.vertices.y = lastInfo.y;
                tmpQuad.tr.texCoords.u = lastInfo.u;
                tmpQuad.tr.texCoords.v = lastInfo.v;
            }
            //3
            tmpQuad.br.vertices.x = lastInfo.x;
            tmpQuad.br.vertices.y = lastInfo.y;
            tmpQuad.br.texCoords.u = lastInfo.u;
            tmpQuad.br.texCoords.v = lastInfo.v;
    
            this._tmpClipQuads[i] = tmpQuad;

            indiceIndex++; 
            if (indiceIndex >= this._indices.length){
                indiceIndex = this._indices.length -1
            }
        }
        return true
    };
})();
